import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'phoneNumber',
})
export class PhoneNumberPipe implements PipeTransform {
  transform(phoneNumber?: number | string): string {
    if (
      phoneNumber === undefined ||
      phoneNumber === null ||
      (typeof phoneNumber === 'string' && (phoneNumber as string).length === 0)
    ) {
      return '';
    }

    const value = phoneNumber.toString().replace(/\D/g, '');

    let areaCode, prefix, lineNumber;

    areaCode = value.slice(0, 3);
    prefix = value.slice(3, 6);
    lineNumber = value.slice(6);

    return '(' + areaCode + ') ' + prefix + '-' + lineNumber;
  }
}
